import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgEditFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.57 9.526 34.087 6.84c-1.464-1.129-2.83-1.095-3.67-.042L28.072 9.74l8.072 6.222 2.345-2.941c.84-1.057.55-2.364-.917-3.495Zm-4.52 10.317-8.072-6.223L9.641 32.862l-.053.067c-.18.222-.205.252-.176.945l-.03 7.304a.422.422 0 0 0 .543.406l6.847-2.039s.572-.11.788-.3l.15-.155 15.34-19.247Z"
            />
        </svg>
    )
}
SvgEditFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgEditFill
